import React, { useEffect } from "react";
import { LocaleProvider, useLocaleContext } from "@quiz/context/LocaleContext";
import UIButton from "../../../../globalComponents/UIComponents/UIButton";

const Preview = ({ quiz, locale }) => {
    const { setLocaleName, getLocaleProperty } = useLocaleContext();

    useEffect(() => {
        setLocaleName(locale);
    }, [locale]);

    const finalScreenTitle = getLocaleProperty(quiz.finalScreen, "title");
    const finalScreenSubitle = getLocaleProperty(quiz.finalScreen, "subtitle");
    const finalScreenButton = getLocaleProperty(quiz.finalScreen, "buttonText");

    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '1.5rem', borderRadius: 14, backgroundColor: '#e9e9e980', maxWidth: 500, flex: 1 }}>
            <div style={{ fontSize: 22, fontWeight: 600 }}>{getLocaleProperty(quiz, "title")}</div>
            <div>
                {finalScreenTitle && <div style={{ fontSize: 18, marginBottom: '1rem' }}>{finalScreenTitle}</div>}
                {finalScreenSubitle && <div style={{ fontSize: 14, marginBottom: '1.5rem' }}>{finalScreenSubitle}</div>}
                {quiz.finalScreen.pictureUrl && <img style={{ width: '100%', borderRadius: 10, maxHeight: '50vh', objectFit: 'cover' }} alt="" src={quiz.finalScreen.pictureUrl} />}
            </div>
            {!!quiz.finalScreen.buttonUrl
                && <a href={quiz.finalScreen.buttonUrl} target="_blank">
                    <UIButton color="primary" fullWidth>
                        {finalScreenButton}
                    </UIButton>
                </a>
            }
        </div>
    </div>
}

export default ({ quiz, locale = 'ru' }) => {
    if (!quiz?.finalScreen) return null;

    return <LocaleProvider>
        <Preview quiz={quiz} locale={locale} />
    </LocaleProvider>
}